module.exports = __webpack_public_path__ + "img/banner_info_plain.34daf57d.webp";